var _rect, _rect2, _rect3, _rect4, _rect5, _path, _polygon, _rect6, _rect7, _rect8, _path2, _polygon2, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyonWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 380",
    fill: "none",
    role: "img",
    "aria-label": "Business workflow automation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 380,
    rx: 20,
    fill: "#F2F6FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 512,
    height: 332,
    rx: 16,
    fill: "#fff",
    stroke: "#D8E3F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 120,
    height: 56,
    rx: 12,
    fill: "#EEF7FF",
    stroke: "#9e00ff",
    opacity: 0.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 58,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#002454",
    opacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 76,
    width: 92,
    height: 8,
    rx: 4,
    fill: "#9e00ff",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 72h52",
    stroke: "#9e00ff",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "222,72 214,68 214,76",
    fill: "#9e00ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 44,
    width: 120,
    height: 56,
    rx: 12,
    fill: "#F4F2FA",
    stroke: "#002454",
    opacity: 0.18
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 58,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#002454",
    opacity: 0.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 76,
    width: 92,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348 72h52",
    stroke: "#9e00ff",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "406,72 398,68 398,76",
    fill: "#9e00ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 44,
    width: 104,
    height: 56,
    rx: 12,
    fill: "#EAFBF2",
    stroke: "#25C16F",
    opacity: 0.45
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 58,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#002454",
    opacity: 0.25
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 426,
    y: 76,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#25C16F",
    opacity: 0.65
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 132,
    width: 472,
    height: 200,
    rx: 14,
    fill: "#FAFBFD",
    stroke: "#E2E8F0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 152,
    width: 140,
    height: 12,
    rx: 6,
    fill: "#002454",
    opacity: 0.16
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 178,
    width: 412,
    height: 14,
    rx: 7,
    fill: "#fff",
    stroke: "#E2E8F0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 182,
    width: 180,
    height: 6,
    rx: 3,
    fill: "#9e00ff",
    opacity: 0.55
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 206,
    width: 412,
    height: 14,
    rx: 7,
    fill: "#fff",
    stroke: "#E2E8F0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 210,
    width: 240,
    height: 6,
    rx: 3,
    fill: "#002454",
    opacity: 0.35
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 234,
    width: 412,
    height: 14,
    rx: 7,
    fill: "#fff",
    stroke: "#E2E8F0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 238,
    width: 300,
    height: 6,
    rx: 3,
    fill: "#25C16F",
    opacity: 0.45
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 270,
    width: 96,
    height: 28,
    rx: 14,
    fill: "#9e00ff",
    opacity: 0.85
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 270,
    width: 96,
    height: 28,
    rx: 14,
    fill: "#002454",
    opacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyonWorkflow);
export default __webpack_public_path__ + "static/media/easyon-workflow.7e9b16ff68871e052ea5efcbd5a44e88.svg";
export { ForwardRef as ReactComponent };